import eye from '../../assets/icons/eyeBlack.svg'
import { Link } from 'react-router-dom'

const ComplaintRow = ({ row, index }) => {
  const truncateText = (text) => {
    const words = text.split(' ')
    if (words.length > 5) {
      return `${words.slice(0, 5).join(' ')}...`
    }
    return text
  }

  const formatDate = (dateString) => {
    const options = { year: '2-digit', month: '2-digit', day: '2-digit' }
    const date = new Date(dateString)
    return date.toLocaleDateString('en-GB', options)
  }

  return (
    <>
      <div className={`${index % 2 === 0 ? '' : ' bg-gray/20'} flex`}>
        <div className="flex-1 p-2 items-center justify-center flex">
          {row.id}
        </div>
        <div className="flex-1 p-2 items-center flex">
          {truncateText(row.text)}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {row.client_name}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {formatDate(row.created_at)}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {row.status}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          <Link
            to={`complaint/${row.id}`}
            className="bg-blue-500 flex gap-1 text-blueButton px-3 py-1 rounded hover:bg-blue-600"
          >
            <span>
              <img src={eye} alt="" />
            </span>
            <span>View</span>
          </Link>
        </div>
      </div>
    </>
  )
}

export default ComplaintRow
